import fromUnixTime from 'date-fns/fromUnixTime';
import format from 'date-fns/format';
import { withExcelBom } from './excelCsv';
import { buildXlsx } from './excelWorkbook';

const downloadBlob = (fileName, blob) => {
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.setAttribute('download', fileName);
  link.setAttribute('href', url);
  link.click();
  return link;
};

export const downloadCsvFile = (fileName, content) =>
  downloadBlob(
    fileName,
    new Blob([withExcelBom(content)], { type: 'text/csv;charset=utf-8;' })
  );

export const downloadXlsxFile = (fileName, rows) =>
  downloadBlob(
    fileName,
    new Blob([buildXlsx(rows)], {
      type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    })
  );

const REPORT_FILE_NAMES = {
  agent: 'relatório-agentes',
  label: 'relatório-etiquetas',
  inbox: 'relatório-caixas-de-entrada',
  team: 'relatório-times',
  conversation: 'relatório-conversas',
  csat: 'relatório-csat',
  sla: 'relatório-sla',
  'Conversation traffic': 'relatório-tráfego-de-conversas',
};

export const generateFileName = ({ type, to, businessHours = false }) => {
  const reportName = REPORT_FILE_NAMES[type] || type;
  let name = `${reportName}-${format(fromUnixTime(to), 'dd-MM-yyyy')}`;
  if (businessHours) {
    name = `${name}-horário-comercial`;
  }
  return `${name}.csv`;
};
